<template>
	<div class="my-40 lg:my-20 flex flex-col gap-4 md:gap-8 items-center justify-center text-center text-gray-400 overflow-y-auto">
		<i class="fa-solid fa-sad-cry text-[96px] md:text-[128px] lg:text-[192px]"/>
		<p class="text-2xl md:text-4xl font-thin">{{ trans('general.empty') }}</p>
	</div>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
</script>